import { render, staticRenderFns } from "./authenPage.vue?vue&type=template&id=30796398&scoped=true&"
import script from "./authenPage.vue?vue&type=script&lang=js&"
export * from "./authenPage.vue?vue&type=script&lang=js&"
import style0 from "./authenPage.vue?vue&type=style&index=0&id=30796398&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30796398",
  null
  
)

export default component.exports